export default {
  login: '/login/login.json', // 登录

  getMap: '/map.json', // 获取地图信息

  updatePwd: '/user/updatePwd.json', //修改密码

  loadGroupsData: '/customer/loadGroupsData.json', //加载车组或批次数据

  delGprsBagInfo: '/homePage/delGprsBagInfo.json', //删除套餐信息

  pushNumSegment: '/stock/pushNumSegment.json', //卡段入库OR批量入库

  addAndUpdateGprsBag: '/homePage/addAndUpdateGprsBag.json', //新增修改套餐

  findByGprsBagList: '/homePage/findByGprsBagList.json', //获取套餐信息列表

  findByGprsBagInfo: '/homePage/findByGprsBagInfo.json', //获取套餐信息详情

  getDestroyCardDetail: '/repertory/getDestroyCardDetail.json', //获取销卡详细信息

  orderCard: '/order/outPutCard.json', //订单出库

  backCard: '/stock/backCard.json', //退卡入库

  chargeOffCard: '/repertory/chargeOffCard.json', //销卡

  getDestroyCardInfo: '/repertory/getDestroyCardInfo.json', //销卡记录列表

  loadSimListByGroups: '/customer/loadSimListByGroups.json', //获得卡组或批次的SIM卡信息

  updateUser: '/user/updateUser.json', //修改客户

  addUser: '/user/addUser.json', //添加用户

  getUserInfo: '/user/getUserInfo.json', //获取用户信息

  getManageUserInfo: '/user/getManageUserInfo.json', //获得用户列表

  getOrderList: '/order/getOrderList.json', //获取订单列表

  getOrderDetail: '/order//getOrderDetail.json', //获取订单详情

  pushCustomerOrder: '/order/pushCustomerOrder.json', //订单提交

  runOrderInfo: '/order/runOrderInfo.json', //销售端设置购买单价  

  setGlobalRisk: '/riskManage/setGlobalRisk.json', //风控管理添加(包含商务端和客户端)

  getNextUserInfo: '/user/getNextUserInfo.json', //获得用户子集用户

  uploadSimExcel: '/stock/uploadSimExcel.json', //批量导入SIM卡

  getClientIndexStopData: '/dealerIndex/getClientIndexStopData.json', //  首页静态数据   已弃用

  getIndexRunData: '/dealerIndex/getIndexRunData.json', // 首页动态数据

  loadInventoryData: 'customer/loadInventoryData.json', //  加载库存

  addSimGroup: '/simGroup/addSimGroup.json', //新增卡组

  loadSimGroup: '/simGroup/loadSimGroup.json', //新增卡组

  clientSearchSimListByInventory: '/customer/clientSearchSimListByInventory.json', //新增卡组

  searchSimListByGroups: '/customer/searchSimListByGroups.json', //搜索卡组下的sim卡信息

  transferGroupSim: "/cardProcess/transferGroupSim.json", //卡片转移到卡组

  transferUserSim: "/cardProcess/transferUserSim.json", //卡片划拨

  sellSimList: "/customer/sellSimList.json", //卡片划拨

  sendBatchSms: "/operator/sendBatchSms.json", //批量短信下发

  getSendSmsStatus: "/operator/getSendSmsStatus.json", //获取批量短信下发的状态

  getDevReply: "/operator/getDevReply.json", //获取单卡的设备回复历史内容

  getIotLlcx: "/operator/getIotLlcx.json", //更新单卡的套餐流量信息

  getSendMsg: "/operator/getSendMsg.json", //获取短信下发记录

  getOrderHistory: "/order/getOrderHistory.json", //获取短信下发记录

  updateSimGroup: "/simGroup/updateSimGroup.json", //   修改卡组信息

  restockUserSim: "/cardProcess/restockUserSim.json", //退卡入库

  getDevReplyNewOne: "/operator/getDevReplyNewOne.json", // 获取SIM卡设备回复的最新一条历史内容

  exportCustomerSim: "/homePage/exportCustomerSim.json", //  首页sim卡导出

  getIotLlcxAll: "/operator/getIotLlcxAll.json", //  首页sim卡导出

  uploadPayCode: "/customer/uploadPayCode.json", // 上传二维码

  getCustomPayCode: "/customer/getCustomPayCode.json", // 获取二维码

  addRemarkOfSim: "/cardProcess/addRemarkOfSim.json", //   获取

  getRiskManage: "/riskManage/queryPredictCard.json", //获取预期/过期卡信息

  getSimGprsCount: "/riskManage/trafficMonitoring.json", //获取预超/以超流量的sim卡数量

  getSimCardsCount: "/riskManage/warnCountOfExpire.json", //获取预/以过期sim卡数量

  exportRiskSimCard: "/exportExcel/exportRiskSimCard.json", //导出所有sim卡信息

  getCountOfStock: "/riskManage/queryCountOfStock.json", //获取出入库数据

  searchSimListByInventory: '/customer/searchSimListByInventory.json', //新增卡组

  searchAllSimListByInventory: "/customer/searchAllSimListByInventory.json", //获取我的卡数据

  transferSimByCustom: "/cardProcess/transferSimByCustom.json", //划拨

  getRecordAll: "/wxUtil/getRecordAll.json", //

  getSendSmsStatusByContentId: "/operator/getSendSmsStatusByContentId.json", //轮询批量短信状态

  /**
  @method getSendSmsStatusByContentId
  @param 轮询批量短信状态
   */
  getSendSmsStatusByContentId: "/operator/getSendSmsStatusByContentId.json", //轮询批量短信状态
  /**
  @method getRefreshTime
  @param 获取当前同步时间
   */
  getRefreshTime: "/dealerIndex/getRefreshTime.json", //获取当前同步时间

  getUserCornInfo: "/recharge/getUserCornInfo.json", //获取用户信息和币数

  getRechargeReport: "/recharge/getRechargeReport.json", //报表查询(充值)

  getTransferReport: "/recharge/getTransferReport.json", //报表查询(划拨记录)

  exportRechargeReport: "/recharge/exportRechargeReport.json", //(充值记录)报表导出

  exportTransferReport: "/recharge/exportTransferReport.json", //(划拨记录)报表导出

  exportConsumeReport: "/recharge/exportConsumeReport.json", //(消费记录)报表导出

  transferCorn: "/recharge/transferCorn.json", //(充值、划拨记录)虚拟币划拨操作

  getCornConsumeReport: "/recharge/getCornConsumeReport.json", //查询消费记录

  renewCardByCorn: "/recharge/renewCardByCorn.json", //计算续费

  exameCornRenew: "/recharge/exameCornRenew.json", //续费操作(扣币后进行年限续费、添加记录)

  setSecondPassword: "/buiness/setSecondPassword.json", //二级密码设置(客户端)

  getPackageKind: "/consume/getPackageKind.json", //获取所有叠加包套餐类型

  checkFlowPackage: "/consume/checkFlowPackage.json", //检测当前客户是否能够线上叠加包(流量池卡)【返回新旧卡区分】

  exameFlowPackage: "/consume/exameFlowPackage.json", //确认当前叠加包操作

  parserExcelToSegment: "/consume/parserExcelToSegment.json", //解析报表数据生成卡段

  queryCustomTips: "/buiness/queryCustomTips.json", //查询客户提示

  modifyCustomTips: "/buiness/modifyCustomTips.json", //修改客户提示信息

  getIotLlcxList: "/operator/getIotLlcxList.json", //批量刷新卡的流量套餐信息

  getSimRenewPriceList: "/renewalManagement/getSimRenewPriceList", //续费单价管理

  updateRenewalManagement: "/renewalManagement/updateRenewalManagement", //修改续费信息

  getUserRenewalRecordBySim: "/userRenewalRecord/getUserRenewalRecord", //用户续费记录查询

  gprsHistory: "/customer/gprsHistory.json", //查询历史流量信息（最近7天数据）

  countFlowConsumeRank: "/newHomePage/countFlowConsumeRank", //流量消耗排行

  countCorn: "/newHomePage/countCorn", //虚拟币统计

  simCardStocks: '/newHomePage/simCardStocks', //卡库存

  CornConsumeCondition: '/newHomePage/CornConsumeCondition', //虚拟币消耗情况

  downloadTemplate: '/snRelation/downloadTemplate', //模板下载

  getSimBySpecifiedField: '/snRelation/getSimBySpecifiedField.json', //sn卡关联搜索

  gerSnRelationAllInfo: '/snRelation/gerSnRelationAllInfo.json', //获取当前用户下所有sn关联信息

  getSnRelationImportTemp: '/snRelation/getSnRelationImportTemp.json', //查询校验的结果（上传设备文件之后调用）

  updateErrorInfo: '/snRelation/updateErrorInfo.json', //修改并校验错误结果(返回修改信息)

  batchAddSnRelation: '/snRelation/batchAddSnRelation.json', //提交录入卡资料（批量添加）

  updateErrorInfo: '/snRelation/updateErrorInfo.json', //修改并校验错误结果(返回修改信息)

  clearImportTemp: '/snRelation/clearImportTemp.json', //清除数据库缓存信息 

  readHistoryGprsFlow: '/api/readHistoryGprsFlow.json', //清除数据库缓存信息 

  getVariousSimCount: '/newHomePage/getVariousSimCount', //获取各种卡数量 

  uploadSN: '/snRelation/upload.json', //获取各种卡数量 

  deleteSubAccount: '/user/deleteSubAccount.json', //删除当前用户下的子用户 

  transferSimCard: '/user/transferSimCard.json', //子用户的卡划拨至其他用户(用于处理删除子用户时，子用户还遗留的卡) 

  confirmGuaranteeInfo: '/guarantee/confirmGuaranteeInfo.json',//确认停机保号费信息

  operationGuaranteeInfo: '/guarantee/operationGuaranteeInfo.json',//审核停机保号费

  updateUserEmail: '/user/updateUserEmail.json',//添加、修改邮箱

  deleteUserEmail: '/user/deleteUserEmail.json',//删除邮箱


  deleteSnInfo: '/snRelation/deleteSnInfo.json',//根据sn号删除设备信息
  batchDeleteSnInfo: '/snRelation/batchDeleteSnInfo.json',//根据sn号批量删除设备信息
  batchAddRemarkOfSim: '/cardProcess/batchAddRemarkOfSim.json',//批量添加备注
  updateSnInfo: '/snRelation/updateSnInfo',//修改设备信息
  getTrafficInfo: '/newHomePage/getTrafficInfo',//获取fc68的流量池信息
  getSpecialCustomOverPrice: '/consume/getSpecialCustomOverPrice',//获取fc68的流量池信息
  queryCardBindStatus: '/wxUtil/queryCardBindStatus',//查询最新物联卡机卡分离状态
  getCardBindStatusRecord: '/wxUtil/getCardBindStatusRecord',//获取SIM卡最近机卡分离记录
  exportSimBySpecifiedField: '/snRelation/exportSimBySpecifiedField',//导出sn相关信息
  pageOrderInfo: '/wechatOrder/pageOrderInfo',//获取PC端续费报表
  pageSnRelationLog: '/snRelationLog/pageSnRelationLog',//分页sn关联修改日志
  updateOrderInfo: '/wechatOrder/updateOrderInfo',//修改订单处理状态
  wechatOrder: '/wechatOrder/exportOrderInfo',//导出续费报表


  pageExternalSimRenewPrice: '/externalSimRenewPrice/pageExternalSimRenewPrice',//分页获取续费价格
  addExternalSimRenewPrice: '/externalSimRenewPrice/addExternalSimRenewPrice',//新增续费价格
  updateExternalSimRenewPrice: '/externalSimRenewPrice/updateExternalSimRenewPrice',//修改续费价格
  deleteExternalSimRenewPrice: '/externalSimRenewPrice/deleteExternalSimRenewPrice',//删除续费价格
  updateExternalSimRenewPriceByDeviceType: '/externalSimRenewPrice/updateExternalSimRenewPriceByDeviceType',//根据设备类型修改续费价格
  exportExternalSimRenewPrice: '/externalSimRenewPrice/exportExternalSimRenewPrice',//导出续费信息
  getExternalSimRenewPrice: '/externalSimRenewPrice/getExternalSimRenewPrice',//根据id获取续费信息
  downloadTemplate: '/externalSimRenewPrice/downloadTemplate.json',//续费资料导入模板下载
  importExternalSimRenewPrice: '/externalSimRenewPrice/importExternalSimRenewPrice',//导入续费资料
  batchUpdateExternalSimRenewPrice: '/externalSimRenewPrice/batchUpdateExternalSimRenewPrice',//批量修改续费价格
  exportNotExternalSimRenewPrice: '/externalSimRenewPrice/exportNotExternalSimRenewPrice',//导出账号下未设值续费价格的卡信息
  readHistoryGprsFlow: '/historyGprsFlow/getNewSimHistoryGprsFlow',//
  monthlyStatisticsOldHistoryGprsFlow: '/historyGprsFlow/monthlyStatisticsOldHistoryGprsFlow',//
  historyReadHistoryGprsFlow: '/historyGprsFlow/readHistoryGprsFlow',//

  downloadSmsSendTemplate: '/smsSend/downloadSmsSendTemplate',//短信发送模板下载
  importSmsSendInfo: '/smsSend/importSmsSendInfo',//批量导入短信信息


}
